import script from "./UIPanelPause.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIPanelPause.vue?vue&type=script&lang=ts&setup=true"

import "./UIPanelPause.vue?vue&type=style&index=0&id=0ecde20d&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ecde20d"]])

export default __exports__